
let href = '../../fragment-impl/js/api/LocalizationSelect.(3D8GmFIDEFQ).css';
if (window.getComputedStyle(document.documentElement).direction === 'rtl') {
	href = '../../fragment-impl/js/api/LocalizationSelect_rtl.(3D8GmFIDEFQ).css';
}

href = import.meta.resolve(href);
const link = document.createElement('link');
link.setAttribute('rel', 'stylesheet');
link.setAttribute('type', 'text/css');
link.setAttribute('href', href);
if (Liferay.CSP) {
	link.setAttribute('nonce', Liferay.CSP.nonce);
}
document.querySelector('head').appendChild(link);
